import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./BoxLoading.module.css";
var BoxLoading = function BoxLoading(_ref) {
  var _ref$numberOfLoaders = _ref.numberOfLoaders,
    numberOfLoaders = _ref$numberOfLoaders === void 0 ? 1 : _ref$numberOfLoaders,
    divHeight = _ref.divHeight,
    divWidth = _ref.divWidth,
    className = _ref.className,
    appearance = _ref.appearance;
  var numberOfLoadersArray = Array.from({
    length: numberOfLoaders
  }, function () {
    return "";
  });
  var innerStyle = _objectSpread(_objectSpread(_objectSpread({}, divHeight ? {
    height: divHeight
  } : {}), divWidth ? {
    width: divWidth
  } : {}), (appearance === null || appearance === void 0 ? void 0 : appearance.opacity) === "dark" ? {
    opacity: 1
  } : {
    opacity: .5
  });

  // Get appropriate color classes based on appearance
  var getColorClass = function getColorClass() {
    if (!(appearance !== null && appearance !== void 0 && appearance.color)) return stl.grayAnimation;
    switch (appearance.color) {
      case "gray":
        return stl.grayAnimation;
      case "green":
        return stl.greenAnimation;
      case "red":
        return stl.redAnimation;
      case "blue":
        return stl.blueAnimation;
      default:
        return "";
    }
  };
  return numberOfLoadersArray.map(function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      style: innerStyle,
      className: [stl.animatedBackground, getColorClass(), className].join(" ")
    });
  });
};
export default BoxLoading;